<!--
무자료 등록 > 등록완료 > 보관장소 수정
-->
<template>
    <div>
        <!-- 보관장소 출력 -->
        <div v-show="editMode === 'none'" class="uk-text-large4 uk-text-center uk-margin-bottom uk-text-primary" title="보관장소">
            {{ prod.storage }}
        </div>

        <div v-show="editMode === 'none'" class="uk-text-center">
            <button
                type="button"
                class="uk-button uk-button-black uk-button-large2 uk-margin-right"
                title="보관장소를 수동으로 입력합니다"
                @click="openManualMode"
            >
                <i class="material-icons">edit</i>
                보관장소 직접작성
            </button>
        </div>

        <!-- 수동작성 모드 -->
        <div v-show="editMode === 'manual'" class="uk-flex uk-flex-center">
            <app-input-text
                ref="inputManualStorage"
                v-model="inputManualStorage"
                class="uk-width-1-2"
                placeholder=""
                input-size="large"

                @keyup.enter="manualSubmit"
            ></app-input-text>

            <button
                type="button"
                class="uk-button uk-button-black uk-button-large"
                @click="manualSubmit"
            >
                <span uk-icon="icon: check"></span>
                저장
            </button>

            <!--- 버튼 -->
            <button
                type="button"
                class="uk-button uk-button-default uk-button-large"
                @click="closeEdit"
            >
                <span uk-icon="icon: close"></span> 취소
            </button>
        </div>
    </div>


</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            // 지역ID
            regionId: Number,

            // 상품정보
            prod: Object,
        },
        data: function () {
            return {
                // 입력 - 보관장소
                inputManualStorage: this.prod.storage,

                // 편집모드 (none: 편집X, manual : 수정)
                editMode: 'none',
            };
        },
        computed: {
        },
        mounted: function () {
            
        },
        methods: {

            openManualMode() {
                this.editMode = 'manual';
                this.inputManualStorage = this.prod.storage;
                this.$refs.inputManualStorage.inputFocus();

            },
            closeEdit() {
                this.editMode = 'none';
                this.$emit('close-edit');
            },

            /**
             * 수동 변경 submit
             */
            manualSubmit() {
                // promise 생성
                let p = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/regions/' + this.regionId + '/nodata-stocks/storage-batch',
                        data: {
                            '_token': this.csrfToken,
                            'prod_ids': JSON.stringify([this.prod.id]),

                            storage:  this.inputManualStorage,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                p.then((response) => {
                    this.prod.storage = this.inputManualStorage;
                    this.closeEdit();
                }).catch(() => {
                    // 오류인경우
                });
            },


        },


    }
</script>
